export default {
  modifyAlternativeName: 'Modificar nombre alternativo.',
  replaceAlternativeName: 'Sustituir nombre alternativo.',
}
